import React from "react";
import { EntityContextInterface } from "module/entity/context/entity/EntityContext";

export type MaintenanceTaskPersonnelAssignmentInternalStaffContextInterface =
  EntityContextInterface;

const MaintenanceTaskPersonnelAssignmentInternalStaffContext =
  React.createContext(
    <MaintenanceTaskPersonnelAssignmentInternalStaffContextInterface>{}
  );

export default MaintenanceTaskPersonnelAssignmentInternalStaffContext;
